import React from "react";
import "./ChangePass.css";

function Forgot() {
  return (
    <div>
      <div className="pass">CONTACT TO YOUR </div>
      <div className="pass">RESPONDING ADMINS</div>
    </div>
  );
}

export default Forgot;
